import React, { useEffect } from 'react';

/**
 * Schedule Meeting Section with extra-large Calendly widget
 * - Uses vanilla iframe approach for maximum compatibility
 */
const ScheduleMeetingSection = () => {
  // Your Calendly booking link for 30-minute consultations
  const calendlyUrl = "https://calendly.com/amvlaw-info/30min";
  
  // Build the full Calendly URL with parameters
  const getFullCalendlyUrl = () => {
    return `${calendlyUrl}?hide_gdpr_banner=1&hide_cookie_banner=1&primary_color=%238e293e&hide_landing_page_details=1&embed_type=Inline`;
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl font-serif">Schedule a Meeting</h2>
          <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Book a consultation with our legal experts at a time that works for you
          </p>
        </div>
        
        {/* Use a direct iframe approach instead of widget script */}
        <div className="max-w-4xl mx-auto rounded-lg overflow-hidden shadow-lg">
          <iframe
            src={getFullCalendlyUrl()}
            width="100%"
            height="1000px"
            frameBorder="0"
            title="Schedule a meeting with AMV LAW"
            style={{
              minWidth: "320px",
              height: "1000px",
              border: "none"
            }}
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ScheduleMeetingSection;